// @ts-ignore
import MoreInfoImg from './more-info.png';

// @ts-ignore
import FaqImg from './faq.png';

// @ts-ignore
import FloatingVideoImg from './floating-video.png';

// @ts-ignore
import NotificationImg from './notification.png';

// @ts-ignore
import OverlayImg from './overlay.png';

// @ts-ignore
import ScrollableOverlay from './scrollable-overlay.png';

export interface PromptUseCases {
  title: string;
  description?: string;
  exampleImage?: string;
  prompt?: string;
  sendPrompt?: boolean;
  openImage?: boolean;
  openSketch?: boolean;
  tooltip?: string;
}

export const PROMPT_USE_CASES: PromptUseCases[] = [
  {
    title: `Generate a block based on a screenshot`,
    openImage: true,
    prompt: `Generate a block that faithfully replicates the design of the uploaded image.
Match the layout, styles, color palette, typography, and overall visual hierarchy as closely as possible.
Ensure the content structure and tone mirror the reference,
while keeping proportions and spacing consistent for a polished and cohesive look.`,
  },
  {
    title: `Generate a block based on sketch`,
    openSketch: true,
  },
  {
    title: `Add "More Info" overlay`,
    prompt: `Create a “More Info” button that opens a overlay with the following spec:

Trigger
  - A button styled as a link, labeled “More Info”.
  - The button is placed inside a container:
  - Container spans 100% width of the parent.
  - Button is centered horizontally in the container.

Overlay Behavior
  - Clicking the button opens the overlay.
  - Overlay is centered horizontally and vertically on the screen.
  - Overlay can be closed via a close button.
  - Inner content should be scrollable.

Overlay Components
  1.  Header - Rich-text title.
  2.  Close Button - An “X” button placed at the top-right corner of the overlay.
  3.  Text Content - Rich-text paragraph.
  4.  Image - Full-width image (spans 100% of overlay’s content area).

Responsive Layout
  - Mobile (viewport < desktop breakpoint): Overlay size: 90vw width × 90vh height.
  - Desktop: Overlay size: 50vw width × 50vh height.`,
    sendPrompt: true,
    tooltip: MoreInfoImg,
  },
  {
    title: `Add a promotion popup`,
    prompt: `Create a “Promotion Popup” that will show upon page load with the following spec:

Overlay Behavior
  - Overlay is centered horizontally and vertically on the screen.
  - Overlay can be closed via a close button.
  - Inner content should be scrollable.

Overlay Components
  1.  Header - Rich-text title. don't use grid to layout the header just use flexbox that spans the full width of the overlay.
  2.  Text Content - Rich-text paragraph.
  3.  CTA - A button styled as a primary button.
  4.  Background Image - Full-width image (spans 100% of overlay’s content area).

Responsive Layout
  - Mobile (viewport < desktop breakpoint): Overlay size: 90vw width × 90vh height.
  - Desktop: Overlay size: 50vw width × 50vh height.
  - On Desktop display the image on the right half of the overlay and the text content and cta on the left half of the overlay.
  `,
    tooltip: OverlayImg,
    sendPrompt: true,
  },
  {
    title: `Add in-app notification popup`,
    prompt: `Create an “In-App Notification Popup” that appears at the top-right corner of the screen with the following spec:
     The notification should be fixed to the top-right corner of the viewport, with a margin of 20px from the top and right edges.
     Animate the notification to slide in from the right when it appears and slide out to the right when it disappears.

Overlay Components
  1.  Icon - A emoji icon on the left side of the notification.
  2.  Text Content - Rich-text paragraph next to the icon.
  3.  Close Button - An “X” button on the far right side of the notification.

Overlay Behavior
  - The notification should automatically disappear after 5 seconds.
  - The notification can be closed immediately by clicking the close button.
  - Expose a variable that will disable the auto hide

Overlay Style
  - Use a subtle shadow to give the notification a slight elevation effect.
  - Use rounded corners with a radius of 8px.
  - Ensure the notification is responsive and looks good on both mobile and desktop devices.
  - Use a light green background color for the notification to indicate success
  - Use white color for the text and icon
  - The layout should be a horizontal flexbox with the icon, text content, aligned center vertically and spaced evenly horizontally
  - The close button should be on the far top-right side of the notification

Responsive Layout
  - Mobile (viewport < desktop breakpoint): Notification size: 90vw width × auto height.
  - Desktop: Notification size: 300px width × auto height.
  - On mobile the fixed wrapper should behave like this:
    position: fixed; top: 20px; left: 0; width: 100%; right: 0; display: flex; justify-content: center; align-items: center;
  - On desktop the fixed wrapper should behave like this:
    position: fixed; top: 20px; right: 20px, left: unset; transform: none width: auto;
`,
    sendPrompt: true,
    tooltip: NotificationImg,
  },
  {
    title: `Add FAQ Section`,
    prompt: `Create an FAQ section with the following spec:
      - The FAQ section should contain a list of questions and answers.
      - Each question should be clickable to expand and reveal the answer.
      - Only one answer should be expanded at a time. Clicking on a different question should collapse the previously expanded answer and expand the new one.
      - Use an accordion style for the questions and answers.
      - The questions should be styled as bold text, and the answers should be styled as regular text.
      - Ensure the FAQ section is responsive and looks good on both mobile and desktop devices.
      - Use a light background color for the FAQ section to make it stand out from the rest of the page.
      - Add some padding around the FAQ section for better spacing.
      - Try to get data from my existing FAQ page if possible.
`,
    sendPrompt: true,
    tooltip: FaqImg,
  },
  {
    title: `Add a scrollable overlay popup`,
    prompt: `Create a “Scrollable Popup” that will show upon page load with the following spec:

Overlay Behavior
  - Overlay can be closed via a close button.
  - Inner content should be scrollable.

Overlay Components
  1.  Header - Rich-text title. don't use grid to layout the header just use flexbox that spans the full width of the overlay. aligned to the left.
  2.  Full width Image
  3.  Text Content - Long rich-text paragraph. aligned to the left

Responsive Layout
  - Mobile (viewport < desktop breakpoint): Overlay size: 100vw width × 90vh height, position on the the bottom of the screen.
    The image should be full-width (spans 100% of overlay’s content area).
  - Desktop: Overlay size: 70vw width × 75vh height, centered horizontally and vertically on the screen.
    The image should be max-width 60% of the overlay’s content area and centered horizontally
  `,
    sendPrompt: true,
    tooltip: ScrollableOverlay,
  },
  {
    title: `Add a floating video`,
    prompt: `Create a “Floating Video” that will show upon page load with the following spec:

Overlay Behavior
  - Overlay can be closed via a close button.
  - Should be draggable around the screen also in mobile.
  - Should auto play and loop the video.
  - When clicking on the video animate the expansion to full screen.

Overlay Components
  1. Floating like element with a shadow and rounded corners. inside that wrapper there should be a video player that can play mp4 videos.
  2. Overlayed play/pause button on the bottom-left corner of the video.
  3. Overlayed close button on the top-right corner of the video.

Full Screen Overlay Behavior
  - When the video is clicked it should animate to full screen.
  - In full screen mode the video should be centered horizontally and vertically on the screen.
  - In full screen mode the video should have a close button on the top-right corner to exit full screen mode.

Overlay Style
  - Use a subtle shadow to give the floating video a slight elevation effect.
  - Use rounded corners with a radius of 8px.
  - The floating video should have a play/pause button overlayed on the bottom-left corner
  - The overlay should be positioned on the bottom-right corner of the screen with a margin of 20px from the bottom and right edges.
  `,
    sendPrompt: true,
    tooltip: FloatingVideoImg,
  },
];
